import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface RegistrationStatusBadgeProps {
  hasTimeRegistration: boolean;
  status: string | null;
}

const STATUS_COLOR_MAP: Record<string, string> = {
  InProgress: '#2196F3',
  Completed: '#FF981F',
  Submitted: '#545C5F',
  Frozen: '#9EA2A2',
  Confirmed: '#008C15',
  Archived: '#9E9E9E',
};

const StatusDot = styled(Box, {
  shouldForwardProp: prop => prop !== 'statusColor',
})<{ statusColor: string }>(({ statusColor }) => ({
  width: 12,
  height: 12,
  borderRadius: '50%',
  backgroundColor: statusColor,
  display: 'inline-block',
}));

const RegistrationStatusBadge = (props: RegistrationStatusBadgeProps) => {
  const { hasTimeRegistration, status } = props;

  if (!hasTimeRegistration) {
    return null;
  }

  const color = status ? STATUS_COLOR_MAP[status] ?? '#9E9E9E' : '#9E9E9E';

  return <StatusDot statusColor={color} />;
};

export default RegistrationStatusBadge;
